module.exports = __webpack_public_path__ + "static/media/dualSeniorActive.699cb858.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/public/userarea/dualSeniorActive.png
// module id = 593
// module chunks = 0